import { render, staticRenderFns } from "./GetPrivilege.vue?vue&type=template&id=75d1adf6&scoped=true"
import script from "./GetPrivilege.vue?vue&type=script&lang=js"
export * from "./GetPrivilege.vue?vue&type=script&lang=js"
import style0 from "./GetPrivilege.vue?vue&type=style&index=0&id=75d1adf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d1adf6",
  null
  
)

export default component.exports